import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
const Portfolio = ({ classicHeader, darkTheme }) => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();

  const filters = {
    WEB: "WEB",
    ECOMMERCE: "ECOMMERCE",
    WEBSITE: "WEBSITE",
    FULLSTACK: "FULLSTACK",
    BACKEND: "BACKEND",
    AI: "AI / ML",
  };

  const projectsData = [
    {
      title: "Refund Desk — AI-Assisted Refund Workflow",
      projectInfo:
        "A full-stack refund workflow built for the WORKNOON technical assessment. Customers submit requests and track decisions, while support teams review escalations and audit notes. AI interprets customer claims; deterministic policy rules govern approvals and denials, with human review for high-value or ambiguous requests. The Docker demo uses synthetic data and includes 34 passing API and policy tests.",
      client: "WORKNOON Technical Assessment",
      technologies:
        "React, Vite, Python, FastAPI, SQLite, OpenAI API integration, Docker Compose, Pytest, GitHub Actions",
      industry: "Customer Support & Workflow Automation",
      date: "October, 2026",
      url: {
        name: "Watch Video Walkthrough",
        link: "https://drive.google.com/file/d/1HhrBuTxryr8iU60S-Zk-2CNJadI5UVGl/view?usp=sharing",
      },
      sourceUrl: {
        name: "View GitHub Repository",
        link: "https://github.com/Yemsquare/worknoon",
      },
      thumbImage: "images/projects/refund-desk.png",
      categories: [filters.FULLSTACK, filters.AI, filters.BACKEND],
    },
    {
      title: "Veil — Privacy-First Social Discovery",
      projectInfo:
        "A full-stack, privacy-first social discovery platform for consenting adults. It combines anonymous profiles, granular photo-vault permissions, mutual identity reveals, real-time messaging, subscription billing, moderation workflows, and a responsive premium interface.",
      client: "Product Development",
      technologies:
        "Next.js 15, TypeScript, Tailwind CSS, Django 5, Django REST Framework, PostgreSQL, Redis, Celery, Django Channels, Docker",
      industry: "Privacy Technology & Social Discovery",
      date: "2026",
      url: {
        name: "View Veil Live",
        link: "https://veil-web-gamma.vercel.app/",
      },
      thumbImage: "images/projects/veil-landing.jpg",
      categories: [filters.FULLSTACK, filters.WEB, filters.BACKEND],
    },
    {
      title: "CoHouse AI",
      projectInfo:
        "An AI-assisted co-housing platform designed to simplify shared accommodation. The monorepo combines property and roommate workflows with a React interface, Django REST APIs, secure backend-managed Gemini integration, and role-based experiences for tenants, landlords, and agents.",
      client: "Product Development",
      technologies:
        "ReactJS, Vite, Django REST Framework, Python, PostgreSQL, Gemini API, JWT, Docker",
      industry: "PropTech & Artificial Intelligence",
      date: "2026",
      url: {
        name: "View CoHouse AI Live",
        link: "https://co-house-ai.vercel.app/",
      },
      thumbImage: "images/projects/cohouse-ai-landing.jpg",
      categories: [filters.FULLSTACK, filters.AI, filters.BACKEND],
    },
    {
      title: "EKKLESIA Backend",
      projectInfo:
        "A modular API platform for Christian devotion, Bible reading, prayer communities, mentorship, premium content, and subscriptions. It includes role-based access, JWT authentication, reading progress, community moderation, payment abstractions, mentor earnings, and documented APIs.",
      client: "Product Development",
      technologies:
        "Django 5, Django REST Framework, PostgreSQL, Redis, Celery, Docker, SimpleJWT, GitHub Actions, OpenAPI",
      industry: "Faith Technology & Community",
      date: "2026",
      thumbImage: "images/projects/ekklesia.svg",
      categories: [filters.BACKEND, filters.FULLSTACK],
    },
    {
      title: "Speech Emotion Recognition",
      projectInfo:
        "A machine-learning project that analyzes audio signals and classifies emotional states from speech, exploring feature extraction and neural-network approaches for human-computer interaction.",
      client: "Research Project",
      technologies:
        "Python, TensorFlow, Keras, Librosa, NumPy, Pandas, Jupyter Notebook, Convolutional Neural Networks",
      industry: "Artificial Intelligence & Audio Analytics",
      date: "2025",
      url: {
        name: "View GitHub Repository",
        link: "https://github.com/Yemsquare/Speech-Emotion-Recognition",
      },
      thumbImage: "images/projects/speech-emotion.svg",
      categories: [filters.AI],
    },
    {
      title: "Bank Customer Segmentation",
      projectInfo:
        "A data-science project that segments banking customers by credit profile, account duration, age, and related characteristics to support targeted services and evidence-based marketing decisions.",
      client: "Data Science Project",
      technologies:
        "Python, Pandas, NumPy, Scikit-learn, Machine Learning, Jupyter Notebook, Data Visualization",
      industry: "Banking Analytics",
      date: "2021",
      url: {
        name: "View GitHub Repository",
        link: "https://github.com/Yemsquare/Customer-Segmentation-Using-Machine-Learning",
      },
      thumbImage: "images/projects/customer-segmentation.svg",
      categories: [filters.AI],
    },
    {
      title: "Swat & Sikeolami Wedding",
      projectInfo:
        "A cinematic digital wedding invitation featuring an immersive 3D envelope reveal, the couple's love story, event itinerary, countdown, Google Sheets-powered RSVP, and one-click calendar reminders. The experience is fully responsive and optimized for mobile guests.",
      client: "Swat & Sikeolami",
      technologies:
        "ReactJS, Vite, JavaScript, CSS3, Google Apps Script, Google Sheets, Calendar Integration, Vercel",
      industry: "Wedding & Events",
      date: "December, 2026",
      url: {
        name: "View Wedding Invitation",
        link: "https://swat-one.vercel.app/",
      },
      thumbImage: "images/projects/swat-wedding.svg",
      categories: [filters.WEB, filters.WEBSITE],
    },
    {
      title: "Magrellos Foods",
      projectInfo:
        "An Online Food Ordering Solutiom.",
      client: "Magrellos Foods",
      technologies: "PHP, WooCormmece, GCP, Jquery, Cart Functionality, HTTP/3, W3 Cache",
      industry: "Foods",
      date: "2023",
      url: {
        name: "www.magrellosfoods.com",
        link: "https://www.magrellosfoods.com",
      },
      // socialLinks: {
      //   facebook: "http://www.facebook.com/",
      //   twitter: "http://www.twitter.com/",
      //   google: "http://www.google.com/",
      //   instagram: "http://www.instagram.com/",
      //   mail: "mailto:example@gmail.com",
      // },
      thumbImage: "images/projects/magrellos 1.png",
      sliderImages: [
        "images/projects/magrellos 2.png",
      ],
      categories: [filters.ECOMMERCE],
    },
    {
      title: "BOLORIMS",
      projectInfo:
        "A Multivendor ecormmerce Website.",
      client: "BEX NG",
      technologies: "GCP, PHP, AJAX, GIT, HTML, CSS, WooCormmerce, NGIX, Mysql, ",
      industry: "Ecormmece",
      date: "2022",
      url: {
        name: "www.bolorims.com",
        link: "https://www.bolorims.com",
      },
      // socialLinks: {
      //   facebook: "http://www.facebook.com/",
      //   twitter: "http://www.twitter.com/",
      //   google: "http://www.google.com/",
      //   instagram: "http://www.instagram.com/",
      //   mail: "mailto:example@gmail.com",
      // },
      thumbImage: "images/projects/bolorims 1.png",
      sliderImages: [
        "images/projects/bolorims 2.png",
        "images/projects/Bolorims 3.png",
      ],
      categories: [filters.ECOMMERCE],
    },
    {
      title: "Ash Xander",
      projectInfo:
        "A Corporate Website.",
      client: "AX Limited",
      technologies: "ReactJS,Github, HTML5, CSS3, Apache, Boostrap, Jquery, Chart.js, Google Font Api",
      industry: "Investment Firm",
      date: "2022",
      url: {
        name: "www.ashxander.com",
        link: "https://www.ashxander.com",
      },
      // socialLinks: {
      //   facebook: "http://www.facebook.com/",
      //   twitter: "http://www.twitter.com/",
      //   google: "http://www.google.com/",
      //   instagram: "http://www.instagram.com/",
      //   mail: "mailto:example@gmail.com",
      // },
      thumbImage: "images/projects/Ash 1.png",
      sliderImages: [
        "images/projects/Ash 2.png",
        "images/projects/Ash 3.png",
      ],
      categories: [filters.WEBSITE],
    },
    {
      title: "Core Asset Management",
      projectInfo:
        "A Corporate Website for Core Asset Management Company",
      client: "Core Asset",
      technologies: "WordPress, HTML5, CSS3, PHP, GCP, Jquery, Apache, Mysql, Tidio, Boostrap, jsDelivr",
      industry: "Investment Firm",
      date: "2023",
      url: {
        name: "www.coreassetng.com",
        link: "https://www.coreassetng.com",
      },
      // socialLinks: {
      //   facebook: "http://www.facebook.com/",
      //   twitter: "http://www.twitter.com/",
      //   google: "http://www.google.com/",
      //   instagram: "http://www.instagram.com/",
      //   mail: "mailto:example@gmail.com",
      // },
      thumbImage: "images/projects/Core 1.png",
      sliderImages: [
        "images/projects/Core 2.png",
        "images/projects/Core 3.png",
      ],
      categories: [filters.WEB, filters.WEBSITE],
    },
    {
      title: "Spectre",
      projectInfo:
        "A Coworking app for a law company.",
      client: "TOLG",
      technologies: "CakePHP, HTML5, CSS3, PHP, DigitalOcean, Git, JavaScript, GitHub Action(CI/CD), CSRF,  API ",
      industry: "Law Firm",
      date: "2021",
      url: {
        name: "www.spectre.com",
        link: "https://spectre.ftabapp.com/",
      },
      // socialLinks: {
      //   facebook: "http://www.facebook.com/",
      //   twitter: "http://www.twitter.com/",
      //   google: "http://www.google.com/",
      //   instagram: "http://www.instagram.com/",
      //   mail: "mailto:example@gmail.com",
      // },
      thumbImage: "images/projects/Spectre 1.png",
      sliderImages: [
        "images/projects/Spectre 2.png",
        "images/projects/Spectre 3.png",
      ],
      categories: [filters.WEB],
    },
    {
      title: "Love of Christ Church",
      projectInfo:
        "A Website for Church.",
      client: "Loccim",
      technologies: "WordPress, HTML5, CSS3, PHP, Mysql, GCP, Apache",
      industry: "Religious",
      date: "2023",
      url: {
        name: "www.loccim.org",
        link: "https://loccim.org/",
      },
      // socialLinks: {
      //   facebook: "http://www.facebook.com/",
      //   twitter: "http://www.twitter.com/",
      //   google: "http://www.google.com/",
      //   instagram: "http://www.instagram.com/",
      //   mail: "mailto:example@gmail.com",
      // },
      thumbImage: "images/projects/loccim 1.png",
      // sliderImages: [
      //   "images/projects/project-1.jpg",
      //   "images/projects/project-5.jpg",
      // ],
      categories: [filters.WEBSITE],
    },
    {
      title: "Daniel Otabor Porfolio Website",
      projectInfo:
        "A Portfolio website for Daniel Otabor",
      client: "Daniel Otabor",
      technologies: "ReactJS, JavaScript, Yaml, SCSS",
      industry: "Portfolio",
      date: "July 16, 2023",
      url: {
        name: "www.danielotabor.com",
        link: "https://www.danielotabor.com",
      },
      // socialLinks: {
      //   facebook: "http://www.facebook.com/",
      //   twitter: "http://www.twitter.com/",
      //   google: "http://www.google.com/",
      //   instagram: "http://www.instagram.com/",
      //   mail: "mailto:example@gmail.com",
      // },
      thumbImage: "images/projects/Daniel 1.png",
      sliderImages: [
        "images/projects/Daniel 2.png",
        "images/projects/Daniel 3.png",
      ],
      categories: [filters.WEB, filters.WEBSITE],
    },
    {
      title: "FMO Website",
      projectInfo:
        "A Corporate Website for FMO Investment Holding Company",
      client: "FMO",
      technologies: "ReactJS, JavaScript, Yaml, SCSS",
      industry: "Portfolio",
      date: "July 16, 2023",
      url: {
        name: "www.fmo.com",
        link: "https://www.fmoholdings.com/",
      },
      // socialLinks: {
      //   facebook: "http://www.facebook.com/",
      //   twitter: "http://www.twitter.com/",
      //   google: "http://www.google.com/",
      //   instagram: "http://www.instagram.com/",
      //   mail: "mailto:example@gmail.com",
      // },
      thumbImage: "images/projects/FMO 1.png",
      sliderImages: [
        "images/projects/FMO 2.png",
        "images/projects/FMO 3.png",
        "images/projects/FMO 4.png",
      ],
      categories: [filters.WEB],
    },
    {
      title: "The Wood Hospitality",
      projectInfo:
        "A Corporate Website for The Wood Hospitality Firm",
      client: "FMO",
      technologies: "ReactJS, JavaScript, Yaml, SCSS",
      industry: "Portfolio",
      date: "August, 2023",
      url: {
        name: "www.TWH.com",
        link: "https://thewood.onrender.com/",
      },
      // socialLinks: {
      //   facebook: "http://www.facebook.com/",
      //   twitter: "http://www.twitter.com/",
      //   google: "http://www.google.com/",
      //   instagram: "http://www.instagram.com/",
      //   mail: "mailto:example@gmail.com",
      // },
      thumbImage: "images/projects/TWH 1.png",
      sliderImages: [
        "images/projects/TWH 2.png",
        "images/projects/TWH 3.png",
        "images/projects/TWH 4.png",
      ],
      categories: [filters.WEBSITE],
    },
    {
      title: "Social Book",
      projectInfo:
        "This is a social media application built using Django and JavaScript. It allows users to create profiles, follow other users, and post content. The app also includes a suggestion feature that recommends users to follow based on their interests, also comment on post, like post and download the post.",
      client: "PERSONAL",
      technologies: "ReactJS, JavaScript, Yaml, SCSS, Python, Django, Git Action, Serverless Cloud, PostgreSql, sql",
      industry: "Social Media",
      date: "December, 2023",
      url: {
        name: "www.social-book.com",
        link: "https://social-book-d452.onrender.com/",
      },
      // socialLinks: {
      //   facebook: "http://www.facebook.com/",
      //   twitter: "http://www.twitter.com/",
      //   google: "http://www.google.com/",
      //   instagram: "http://www.instagram.com/",
      //   mail: "mailto:example@gmail.com",
      // },
      thumbImage: "images/projects/Social 1.png",
      sliderImages: [
        "images/projects/Social 2.png",
        "images/projects/Social 3.png",
        
      ],
      categories: [filters.WEB],
    },
    {
      title: "SourceKing",
      projectInfo:
        "SourceKing is a team of experts providing tailored solutions to businesses and individuals in global trade, sustainable practices, and critical resource sourcing.",
      client: "PERSONAL",
      technologies: "ReactJS, PHP, WordPress, CSS, JS",
      industry: "Consultant",
      date: "February, 2024",
      url: {
        name: "SourceKing",
        link: "https://sourceking.net/",
      },
      // socialLinks: {
      //   facebook: "http://www.facebook.com/",
      //   twitter: "http://www.twitter.com/",
      //   google: "http://www.google.com/",
      //   instagram: "http://www.instagram.com/",
      //   mail: "mailto:example@gmail.com",
      // },
      thumbImage: "images/projects/SoourceKing.png",
      sliderImages: [
        "images/projects/SourceKing1.png",
        "images/projects/SourceKing2.png",
        
      ],
      categories: [filters.WEB, filters.WEBSITE],
    },
    {
      title: "GGBLifestyle",
      projectInfo:
        "Girls Got Bold Dance Crew abbreviated GGB Dance Crew is an all female dance crew based in Lagos.",
      client: "ASH XANDER",
      technologies: "ReactJS, PHP, WordPress, CSS, JS",
      industry: "Consultant",
      date: "September, 2024",
      url: {
        name: "GGBLifestyle",
        link: "https://ggblifestyle.com/",
      },
      // socialLinks: {
      //   facebook: "http://www.facebook.com/",
      //   twitter: "http://www.twitter.com/",
      //   google: "http://www.google.com/",
      //   instagram: "http://www.instagram.com/",
      //   mail: "mailto:example@gmail.com",
      // },
      thumbImage: "images/projects/GGB1.png",
      sliderImages: [
        "images/projects/GGB2.png",
        "images/projects/GGB3.png",
        
      ],
      categories: [filters.WEB],
    },
    {
      title: "Cedoni Interiors",
      projectInfo:
        "Cedoni Interiors specializes in bespoke furniture, elegant soft furnishings, smart home integration, and complete interior design solutions that blend style, functionality, and innovation.",
      client: "Bellvi Professionals",
      technologies: "ReactJS, PHP, WordPress, CSS, JS",
      industry: "Interiors",
      date: "May, 2025",
      url: {
        name: "Code Interiors",
        link: "https://cedoniinteriors.com/",
      },
      // socialLinks: {
      //   facebook: "http://www.facebook.com/",
      //   twitter: "http://www.twitter.com/",
      //   google: "http://www.google.com/",
      //   instagram: "http://www.instagram.com/",
      //   mail: "mailto:example@gmail.com",
      // },
      thumbImage: "images/projects/codeniinterior1.png",
      sliderImages: [
        "images/projects/codeniinteriors2.png",
        "images/projects/codeniinterior1.png",
        
      ],
      categories: [filters.WEB, filters.WEBSITE],
    },
    {
      title: "FBDS Distribution",
      projectInfo:
        "FBDS Distribution Services Inc. provides specialized products distribution and market entry advisory services to suppliers and retailer.",
      client: "Bellvi Professionals",
      technologies: "ReactJS, PHP, WordPress, CSS, JS",
      industry: "Importer/Exporter",
      date: "September, 2025",
      url: {
        name: "FBDS Distribution",
        link: "https://fbdsdistribution.com/",
      },
      // socialLinks: {
      //   facebook: "http://www.facebook.com/",
      //   twitter: "http://www.twitter.com/",
      //   google: "http://www.google.com/",
      //   instagram: "http://www.instagram.com/",
      //   mail: "mailto:example@gmail.com",
      // },
      thumbImage: "images/projects/fbds_1.png",
      sliderImages: [
        "images/projects/fbds_2.png",
        "images/projects/fbds_3.png",
        "images/projects/fbds_4.png",
        
      ],
      categories: [filters.WEBSITE],
    },
    {
      title: "Ogelite Nnaji",
      projectInfo:
        "Ogechukwu Nnaji, popularly known as ogelite, is a passionate lover of God am a music minister and a dedicated life coach.",
      client: "Bellvi Professionals",
      technologies: "ReactJS, PHP, WordPress, CSS, JS",
      industry: "Music",
      date: "April, 2025",
      url: {
        name: "Ogelite Nnaji",
        link: "https://ogelitennaji.com/",
      },
      // socialLinks: {
      //   facebook: "http://www.facebook.com/",
      //   twitter: "http://www.twitter.com/",
      //   google: "http://www.google.com/",
      //   instagram: "http://www.instagram.com/",
      //   mail: "mailto:example@gmail.com",
      // },
      thumbImage: "images/projects/ogelite1.png",
      sliderImages: [
        "images/projects/ogelite2.png",
        "images/projects/ogelite3.png",
        
      ],
      categories: [filters.WEBSITE],
    },
   
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey.replace(/[^a-zA-Z0-9_-]/g, "-")}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  return (
    <>
      <section
        id="portfolio"
        className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
      >
        <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
          {/* Heading */}
          <div className="position-relative d-flex text-center mb-5">
            <h2
              className={
                "text-24  text-uppercase fw-600 w-100 mb-0 " +
                (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
              }
            >
              Portfolio
            </h2>
            <p
              className={
                "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
                (darkTheme ? "text-white" : "text-dark")
              }
            >
              {" "}
              My Work
              <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
            </p>
          </div>
          {/* Heading end*/}
          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu nav nav-tabs justify-content-center border-bottom-0 mb-5 " +
              (darkTheme ? "nav-light" : "")
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                All
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " +
                    (filterKey === filters[oneKey] ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(filters[oneKey])}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio popup-ajax-gallery">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      project.categories.map((category) => category.replace(/[^a-zA-Z0-9_-]/g, "-")).join(" ")
                    }
                    key={index}
                  >
                    <div className="portfolio-box rounded">
                      <div className="portfolio-img rounded">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div className="portfolio-overlay">
                         <button
                            type="button"
                            className="popup-ajax stretched-link border-0 bg-transparent p-0 w-100 h-100"
                            onClick={() => {
                              setSelectedProjectDetails(project);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                            aria-label={`View details for ${project.title}`}
                          >
                            <span className="visually-hidden">
                              View details for {project.title}
                            </span>
                          </button>
                        <div className="portfolio-overlay-details">
                            <h5 className="text-white fw-400">
                              {project.title}
                            </h5>
                            <span className="text-light">Category</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      <div className="project-details-modal">
        {/* Modal */}
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          darkTheme={darkTheme}
        ></ProjectDetailsModal>
      </div>
    </>
  );
};

export default Portfolio;
